import { ceil, times } from 'lodash';
import { Flex, Icon, Text } from 'mymoria-ui/components';
import { SpaceProps } from 'mymoria-ui/interfaces';
import { colors } from 'mymoria-ui/styles';
import { styled } from 'mymoria-ui/utils';
import { FunctionComponent } from 'react';
import { space } from 'styled-system';

const StyledRating = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  svg {
    width: 21px;
    height: 20px;
    margin: 0 4px;

    &:first-of-type {
      margin: 0 4px 0 0;
    }
  }

  p {
    margin: 0 0 0 4px;
  }

  ${space}
`;

interface Props extends SpaceProps {
  rating: number;
  caption: string;
  captionColor?: keyof typeof colors;
}

const Rating: FunctionComponent<Props> = ({
  rating,
  caption,
  captionColor = 'primary',
  ...props
}) => (
  <StyledRating ml="small" {...props}>
    <Flex>
      {times(ceil(rating), index => (
        <Icon.RatingStar key={index} />
      ))}
    </Flex>
    {caption && (
      <Text color={captionColor} fontSize="small" textAlign="start" pt={0}>
        {caption}
      </Text>
    )}
  </StyledRating>
);

export default Rating;
